export default __webpack_public_path__ + "static/media/ContactBg.1c4015b0.mp4";